var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckOriginal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31482 10.7326L6.84515 11.263L6.84515 11.263L6.31482 10.7326ZM5.01852 10.7326L5.54885 10.2023L5.01852 10.7326ZM12.803 3.18379L5.78448 10.2023L6.84515 11.263L13.8637 4.24445L12.803 3.18379ZM5.78449 10.2023C5.7209 10.2659 5.61244 10.2659 5.54885 10.2023L4.48819 11.263C5.13756 11.9123 6.19577 11.9123 6.84515 11.263L5.78449 10.2023ZM5.54885 10.2023L2.53033 7.18379L1.46967 8.24445L4.48819 11.263L5.54885 10.2023Z",
    fill: "#29282C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOriginal);
export default __webpack_public_path__ + "static/media/checkOriginal.66de2fb232eb26b74f2de90e9ae606db.svg";
export { ForwardRef as ReactComponent };